import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';

import { ElementDataType } from '@/components/sections/builder/elements/body/content-pages/type';
import { shallow } from 'zustand/shallow';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const content = element.data as ElementDataType;

  return (
    <div>
      <div className='mb-1 text-sm md:mt-4'>Background Color Scheme</div>
      <SchemeSetting
        value={content.colorSchemeCompanyContent}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorSchemeCompanyContent: theme,
          });
        }}
      />
      <div className='mb-1 mt-4 text-base font-bold md:mt-4'>Section Padding</div>
      <PaddingSetting
        value={content.padding}
        onChange={(padding) => {
          builder.setElementData(element.id, {
            padding,
          });
        }}
      />
    </div>
  );
}
